'use strict'



// PARALLAX
//Module technique #1 : Le titre de la page disparait vers le bas lors du scoll +
//le headboard disparait lorsqu'on scroll vers le bas et réaparait lorsque l'on scoll vers le haut
window.addEventListener("scroll", function() {
  const distance = window.scrollY;
  const myBody = this.document.querySelector('body');
  if(typeof myBody.dataset.page !== undefined){
    document.querySelector("." + myBody.dataset.page + " .parallax").style.transform = `translateY(${distance * 1}px)`;
    document.querySelector("." + myBody.dataset.page + " .h1title").style.transform = `translateY(${distance * 0.3}px)`;
  }
});

let navbar = document.querySelector(".navbar");
let prevScrollpos = window.pageYOffset;
window.addEventListener("scroll", function() {
  let currentScrollPos = window.pageYOffset;
  if (prevScrollpos > currentScrollPos) {
    navbar.classList.add("navbar--visible");
  } else {
    navbar.classList.remove("navbar--visible");
  }
  prevScrollpos = currentScrollPos;
});



// FILTRE
//Module technique #2 : Filtrage de mon Json pour trouver des informations sur les colocataires
function ready(fn) {
  if (document.readyState != 'loading'){
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

const colocList= document.querySelector('.colocataire');
const findEl = document.querySelector('#form_search');
const errorBlock = document.querySelector("#errors");

ready(function(){
  if(findEl !== null){
    initMyColocataire();
    findEl.addEventListener('submit', function(e) {
      e.preventDefault();
      colocList.innerHTML = '';
      errorBlock.innerHTML = '';
      const searchword = document.querySelector('#information').value.toLowerCase();
      if(searchword.length <= 0) {
        errorBlock.innerHTML = "Veuillez entrer une rechercher";
        initMyColocataire();
      }
      else{
        fetch('info.json').then(function (response) {
          return response.json();
        }).then(function (json) {
          var resultHTML = "";
          var numOfResults = 0;
          json.forEach((data) => {
            if(
              data.prenom.toLowerCase().indexOf(searchword) > -1
              || data.nom.toLowerCase().indexOf(searchword) > -1
              || data.statut.toLowerCase().indexOf(searchword) > -1
              || data.mail.toLowerCase().indexOf(searchword) > -1
              || data.telephone.toLowerCase().indexOf(searchword) > -1
            ){
              numOfResults++;
              const result = '<ul class="emilie">' +
                '<li class="test">'+ data.prenom + ' ' + data.nom +'</li>' +
                '<li>'+ data.statut +'</li>'+
                '<li>'+ data.mail +'</li>'+
                '<li>'+ data.telephone +'</li>'+
              '</ul>';
              resultHTML += result;
            }
            else{        
              if(numOfResults == 0){
                errorBlock.innerHTML = "Il n'y a pas de résultat pour votre recherche";
              }
            }
          });
          colocList.innerHTML = resultHTML;
        });
      }    
    });  
  }
});

function initMyColocataire(){
  fetch('info.json').then(function (response) {
    return response.json();
  }).then(function (json) {
    var resultHTML = "";
    json.forEach((data) => {
      const result = '<ul class="emilie">' +
        '<li class="test">'+ data.prenom + ' ' + data.nom +'</li>' +
        '<li>'+ data.statut +'</li>'+
        '<li>'+ data.mail +'</li>'+
        '<li>'+ data.telephone +'</li>'+
      '</ul>';
      resultHTML += result;
    });
    colocList.innerHTML = resultHTML;
  });
}

function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

// BURGER MENU

var burgerBtn = document.querySelector('.burger');
if(links !== null){
  burgerBtn.addEventListener('click', function (e) {
    toggleHidden()
  });
}


var links = document.querySelectorAll('.menu__links--page');
if(links !== null){
  links.forEach(function (element) {
    element.addEventListener('click', function (e) {
      e.preventDefault(); 
  
      var clicked_link = e.currentTarget; 
  
      var hrefValue = clicked_link.getAttribute("href");
      document.body.setAttribute('data-page', hrefValue);
  
      toggleHidden();
      topFunction();
    });
  });
}


function toggleHidden(){
  var menuList = document.querySelector("html");
  menuList.classList.toggle("menu-open");
}



// FORMULAIRE
//Module technique #3 (pas proposé mais au final compte comme un petit module): Toggle
//Modules techniques #4 : Formulaire de proposition d'événement et affichage des réponses

var burgermenu = document.querySelector('.plusBtn');
if(burgermenu !== null){
  burgermenu.addEventListener('click', function (e) {
    var Elementmenu = document.querySelector(".formulaire");
    Elementmenu.classList.toggle("hidden");
  });
}



const button = document.getElementById('clearBtn')
const form = document.querySelector('#form_event')
const ul = document.getElementById('ulEvent')

const dateInput = document.getElementById('date')
const hourInput = document.getElementById('hour')
const echeanceInput = document.getElementById('echeance')
const categInput = document.getElementById('categ')
const minInput = document.getElementById('min')
const maxInput = document.getElementById('max')
const comInput = document.getElementById('commentaires')

let itemsArray = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : []

localStorage.setItem('items', JSON.stringify(itemsArray))
const data = JSON.parse(localStorage.getItem('items'))

const liMaker = text => {
  const li = document.createElement('li')
  li.textContent = text
  ul.appendChild(li)
}

if(form !== null){
  form.addEventListener('submit', function(e) {
    e.preventDefault()
  
    let myEvent = {};
  
    myEvent.date = dateInput.value;
    liMaker(dateInput.value)
    dateInput.value = ''
  
    myEvent.hour = hourInput.value;
    liMaker(hourInput.value)
    hourInput.value = ''
  
    myEvent.echeance = echeanceInput.value;
    liMaker(echeanceInput.value)
    echeanceInput.value = ''
  
    myEvent.category = categInput.value;
    liMaker(categInput.value)
    categInput.value = ''
  
    myEvent.min = minInput.value;
    liMaker(minInput.value)
    minInput.value = ''
  
    myEvent.max = maxInput.value;
    liMaker(maxInput.value)
    maxInput.value = ''
  
    myEvent.com = comInput.value;
    liMaker(comInput.value)
    comInput.value = ''
  
    itemsArray.push(myEvent);
  
    localStorage.setItem('items', JSON.stringify(itemsArray))
  
    var Elementmenu = document.querySelector(".formulaire");
    Elementmenu.classList.toggle("hidden");
  })
}




data.forEach(item => {
  liMaker(item.date)
  liMaker(item.hour)
  liMaker(item.echeance)
  liMaker(item.categ)
  liMaker(item.min)
  liMaker(item.max)
  liMaker(item.com)
})


//To clear all
if(button){
  button.addEventListener('click', function() {
    localStorage.clear()
    while (ul.firstChild) {
      ul.removeChild(ul.firstChild)
    }
  })
}

